import { Tag } from 'antd';
import React from 'react';
import i18n from '@/i18n';
import { isAndroid } from '@/infrastructure/product-info';
import { formatCompareTimeRange } from '@/presentation/components/compare/api';
import {
  renderCharacterInputValue,
} from '@/presentation/components/compare/list';
import { FieldKey, getLocalFieldLabelByValue } from '@/proto/field';
import { MetricType } from '@/proto/metric';

export const getColumn = (metricType: MetricType) => (
  [
    { title: i18n.t('时间范围'), dataIndex: FieldKey.TimeRange },
    { title: i18n.t('APP版本'), dataIndex: FieldKey.AppVersion, render: renderCharacterInputValue },
    { title: i18n.t('系统版本'), dataIndex: FieldKey.OsVersion, render: renderCharacterInputValue },
    { title: i18n.t('SDK版本'), dataIndex: FieldKey.SdkVersion },
    { title: i18n.t('机型'), dataIndex: FieldKey.Model, disabled: metricType !== MetricType.TYPE_MEMORY },
    { title: i18n.t('进程'), dataIndex: FieldKey.ProcessName, disabled: !isAndroid() },
    { title: i18n.t('32/64位1'), dataIndex: FieldKey.Bit, disabled: metricType !== MetricType.TYPE_MEMORY || !isAndroid(), render: (value: string) => getLocalFieldLabelByValue(FieldKey.Bit, value) },
    { title: i18n.t('FD类型'), dataIndex: FieldKey.FdType, disabled: metricType !== MetricType.TYPE_FD_LEAK, render: (value: string) => getLocalFieldLabelByValue(FieldKey.FdType, value) },
  ]
);

export const newColumn = (_metricType?: MetricType) => (
  [
    {
      title: i18n.t('时间范围'),
      dataIndex: FieldKey.TimeRange,
      width: 200,
      ellipsis: true,
      render: (val: string[]) => formatCompareTimeRange(val) || '--',
    },
    {
      title: i18n.t('查询条件'),
      dataIndex: '_conditions',
      render: (conditions: Array<{ label: string; value: string }>) => {
        if (!conditions?.length) return '--';
        return React.createElement(
          'div',
          { style: { display: 'flex', flexWrap: 'wrap' as const, gap: 4 } },
          conditions.map((item, idx) => React.createElement(Tag, { key: idx, color: 'processing' }, `${item.label}：${item.value}`)),
        );
      },
    },
  ]
);
